"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vairano-patenora": {
    "c594ed67": [{
      "hkey": "bd111663",
      "slug": "vairano-patenora",
      "name": "Vairano Patenora",
      "primary": true,
      "skipSearch": false
    }],
    "taverna-catena": [{
      "hkey": "bd111663",
      "slug": "vairano-patenora",
      "name": "Vairano Patenora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;